// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Input from 'components/common/Input';
import Row from 'components/common/Row';
import Col from 'components/common/Col';
// COMPONENTS
import MoneyInput from 'components/inputs/MoneyInput';

// SEE: https://ant.design/components/form/#components-form-demo-customized-form-controls
class LineItemInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      description: this.props.value.description,
      amount: this.props.value.amount,
    };
  }

  componentWillReceiveProps({ value }) {
    // Should be a controlled component.
    if (value) {
      this.setState(value);
    }
  }

  getAmountAsFloat(amount) {
    if (!amount || !amount.includes('.')) {
      let length = amount.length;
      return amount.substring(0, length - 2) + '.' + amount.substring(length - 2);
    }
    return amount;
  }

  handleDescriptionChange = e => {
    if (!('value' in this.props)) {
      this.setState({ description: e.target.value });
    }
    this.triggerChange({ description: e.target.value });
  };

  handleAmountChange = value => {
    // const { value } = e.target;

    const amount = value.toString().replace(',', '');

    if (!('value' in this.props)) {
      this.setState({ amount });
    }
    this.triggerChange({ amount });
  };

  triggerChange = changedValue => {
    // Should provide an event to pass value to Form.
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(Object.assign({}, this.state, changedValue));
    }
  };
  
  render() {
    const { size } = this.props;

    return (
      <Row gutter={20}>
        <Col xs={16} sm={19}>
          <Input
            placeholder="description here..."
            value={this.state.description}
            size={size || 'large'}
            onChange={this.handleDescriptionChange}
            style={{ width: '100%', marginRight: 8 }}
          />
        </Col>
        <Col xs={8} sm={5}>
          <MoneyInput
            className="ant-input ant-input-lg"
            value={this.getAmountAsFloat(this.state.amount)}
            placeholder="amount"
            currencySymbol={this.props.currencySymbol}
            onChange={this.handleAmountChange}
          />
        </Col>
      </Row>
    );
  }
}

LineItemInput.defaultProps = {
  'value.description': '',
  'value.amount': '0.00',
};

export default LineItemInput;



// WEBPACK FOOTER //
// ./src/components/inputs/LineItemInput/index.js